import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { supplierSpendFiltersSelector } from '../../store/selectors/reportsSelectors';
import { supplierSpendReportOrderingSelector } from '../../store/selectors/coreOrderingSelectors';
import { getSupplierSpendReportOrderingThunk } from '../../store/thunks/core/coreOrderingThunks';
import { SupplierSpendReportOrdering } from '../enum/ReportTableOrders';
import { setSupplierSpendReportFilters } from '../../store/slices/reportsSlice';
import { initPaging } from '../../core/types/coreTypes';

export const useSupplierSpendReportDefaultOrdering = () => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(supplierSpendFiltersSelector);
  const ordering = useAppSelector(supplierSpendReportOrderingSelector);
  const [defaultOrder, setDefaultOrder] = useState<number | null>(null);

  useEffect(() => {
    if (!ordering.length) {
      dispatch(getSupplierSpendReportOrderingThunk());
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!filters.order?.field) {
      const defaultOrdering = ordering.find((el) => el.label === SupplierSpendReportOrdering.PurchaseOrderDate)?.value;
      if (defaultOrdering) {
        setDefaultOrder(defaultOrdering);
        dispatch(setSupplierSpendReportFilters({ ...filters, order: { field: defaultOrdering, isAsc: false } }));
      }
    }
    // eslint-disable-next-line
  }, [ordering]);

  return {
    ...initPaging,
    order: defaultOrder ? { field: defaultOrder, isAsc: false } : filters.order,
  };
};
